module.exports = {"341222100":"城关镇","341222101":"旧县镇","341222102":"税镇镇","341222103":"皮条孙镇","341222104":"原墙镇","341222105":"倪邱镇","341222106":"李兴镇","341222107":"大新镇","341222108":"肖口镇","341222109":"关集镇","341222110":"三塔镇","341222111":"双浮镇","341222112":"蔡庙镇","341222113":"三堂镇","341222114":"苗老集镇","341222115":"赵庙镇","341222116":"宫集镇","341222117":"坟台镇","341222118":"洪山镇","341222119":"清浅镇","341222120":"五星镇","341222121":"高庙镇","341222122":"桑营镇","341222123":"大庙集镇","341222124":"阮桥镇","341222125":"双庙镇","341222126":"胡总镇","341222127":"郭庙镇","341222128":"二郎镇","341222129":"马集镇","341222201":"赵集乡","341222400":"开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341222.json
// module id = 1231
// module chunks = 0